import { makeStyles } from '@material-ui/core';
import { useEffect, useState } from 'react';

export const useAutocompleteFields = <T>(
  findFunction: (searchValue: string) => T[],
  searchValueMinLength: number = 1,
) => {
  const [optionList, setOptionList] = useState<T[]>([]);
  const [searchValue, setSearchValue] = useState<string>('');

  const useStyles = makeStyles((theme) => {
    return {
      underline: {
        '&.Mui-error:after': {
          borderBottomColor: `${theme.palette.error.main} !important`,
        },
      },
    };
  });

  const classes = useStyles();

  useEffect(() => {
    if (!searchValue) {
      setOptionList([]);
    }
    if (searchValue?.length < searchValueMinLength) return;
    const list = findFunction(searchValue);
    setOptionList(list);
  }, [searchValue]);

  return {
    classes,
    optionList,
    setSearchValue,
  };
};
